<template>
  <div class="study-table">
    <!-- <div class="title">
      查看统计信息 | 总共
      <span v-text="num"></span>条数据
    </div> -->
    <div class="constraint">
      每页显示10条
      <!-- <input type="number" :value="currentNum"  /> 条 -->
    </div>
    <div class="table">
      <el-table :data="tableData" style="width: 100%" :default-sort="{prop: 'name'}">
        <el-table-column
          v-for="(column,index) in columns"
          :key="index"
          :prop="column.prop"
          :label="column.name"
          sortable
        ></el-table-column>
        <el-table-column fixed="right" label="操作" width="80" v-if="shows">
          <template slot-scope="scope">
            <el-button
              @click.native.prevent="deleteRow(scope.$index, tableData)"
              type="text"
              size="small"
            >查看详情</el-button>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="name" label="学习条数"></el-table-column> -->
      </el-table>
    </div>
    <div class="page">
      <el-pagination
        background
        layout="prev, pager, next"
        :small="true"
        :page-count="pages"
        @prev-click="prev"
        @next-click="next"
        @current-change="current"
      ></el-pagination>
    </div>
  </div>

</template>
<script>
export default {
  data() {
    return {
      currentNum: 10,
    };
  },
  name: "studyTable",
  props: {
    name: String,
    columns: Array,
    tableData: Array,
    shows: Boolean,
    pages:Number,
    num:Number,
  },
  methods: {
    prev(pages) {
      console.log(pages);
    },
    next(pages) {
      console.log(pages);
    },
    current(pages) {
      console.log("just click pages", pages);
      let par = this.$parent;
      par.tableDataTemp = [];
      for (let x = (pages-1) * 10; x < par.tableData.length; x++) {
        if (x ==pages * 10) return;
        else par.tableDataTemp.push(par.tableData[x]);
      }
    },
    test() {
      if (this.columns[0].under) {
      }
    },
    deleteRow(index, data) {
      this.$emit('nextTable',true,data[index].areaname)
    },
    getParent() {
      console.log("children", this.tableData);

      // this.tableDataTemp = this.tableData
    }
  },

  mounted() {}
};
</script>
<style lang='scss' scoped>
.study-table {
  .page {
    width: 100%;
    padding: 0.3rem 0;
  }
  .constraint {
    input {
      margin: 0 0.2rem;
      width: 0.5rem;
      padding: 0 0.05rem;
    }
    display: flex;
    align-items: center;
    padding: 0 0.2rem;
  }
  .title {
    line-height: 3;
    padding: 0 0.2rem;
  }
  background: #fff;
  margin-top: 0.05rem;
  min-height: 72vh;
}
</style>

<style lang="scss">
.study-table {
  .el-pagination {
    display: flex;
    justify-content: space-around;
  }
  .table {
    th,
    td {
      text-align: center;
      border-right: 0.01rem solid #e6e6e6;
    }

    th {
      background: #f9f99f;
      // border-right: .01rem solid #e6e6e6;
      font-size: 0.2rem;
    }
    width: 94%;
    margin: 0.3rem auto;
    border-left: 0.01rem solid #e6e6e6;
  }
}
</style>